import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Untersuchungsgruppe } from './untersuchungsgruppe';
import { UntersuchungsgruppeDialogComponent } from './untersuchungsgruppe-dialog/untersuchungsgruppe-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-untersuchungsgruppe',
    templateUrl: './untersuchungsgruppe.component.html',
    styleUrls: ['./untersuchungsgruppe.component.scss'],
})
export class UntersuchungsgruppeComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneTableService,
        private readonly notification: MessageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Untersuchungsgruppen';
        this.tableDescriptor.uniqueIdentifier = 'Untersuchungsgruppen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'untersuchungsgruppe/';
        this.tableDescriptor.route = '/labor/unteruchungsgruppen/';
        this.tableDescriptor.nameOfIdField = 'untersuchungsgruppe_id';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;

        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Untersuchungsgruppe'));

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'bearbeiten', 'edit', 1));
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'löschen', 'delete', 1));

        this.tableDescriptor.permissionCreate = 1233;
        this.tableDescriptor.permissionView = 1231;

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddDialog.bind(this);
    }

    openDeleteDialog(untersuchungsgruppe: Untersuchungsgruppe) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: {
                title: untersuchungsgruppe.bezeichnung + ' löschen',
                text: 'Wollen Sie ' + untersuchungsgruppe.bezeichnung + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api
                    .deleteEntity(this.apiBaseUrl + 'untersuchungsgruppe/delete.php', untersuchungsgruppe)
                    .subscribe(
                        () => {
                            this.notification.infoMessage('Untersuchungsgruppe erfolgreich gelöscht!');
                            this.api.reload();
                        },
                        error => {
                            this.notification.errorMessage('Untersuchungsgruppe konnte nicht gelöscht werden!', error);
                        },
                    );
            }
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(UntersuchungsgruppeDialogComponent, { width: '50%', minWidth: '300px' });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const ug = <Untersuchungsgruppe>result;
                this.api.updateEntity(this.apiBaseUrl + 'untersuchungsgruppe/update.php', ug).subscribe(
                    () => {
                        this.notification.infoMessage('Untersuchungsgruppe erfolgreich gespeichert!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Untersuchungsgruppe konnte nicht gespeichert werden!', error);
                    },
                );
            }
        });
    }

    openEditDialog(untersuchungsgruppe: Untersuchungsgruppe) {
        const dialogRef = this.dialog.open(UntersuchungsgruppeDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { untersuchungsgruppe: untersuchungsgruppe },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const ug = <Untersuchungsgruppe>result;
                this.api.updateEntity(this.apiBaseUrl + 'untersuchungsgruppe/update.php', ug).subscribe(
                    () => {
                        this.notification.infoMessage('Untersuchungsgruppe erfolgreich gespeichert!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Untersuchungsgruppe konnte nicht gespeichert werden!', error);
                    },
                );
            }
        });
    }
}
